import { RelatedUserApp } from './related-user-app';
import { RelatedUserRole } from './related-role';
import { UserSecurityGroup } from './user-security-group';
import { RelatedUser } from './related-user';
import { RelatedTerritory } from './related-territory';
import { Address } from './address'

export enum UserStatuses { Employed = 'Employed', Retired = 'Retired', Terminated = 'Terminated', Resigned = 'Resigned', Unknown = 'Unknown', System = 'System' };

export class User {
    public id: string = null;
    public person_Id: string = null;
    public oid: string = null;
    public slprsnid: string = null;
    public gpSamplesCUSTNMBR: string;
    public color: string;
    public displayName: string = null;
    public mail: string = null;
    public mailNickname: string = null;
    public userPrincipalName: string = null;
    public workPhone: string = null;
    public mobilePhone: string = null;
    public isAdmin: boolean = false;
    public userType: string = null;
    public userStatus: string = null;
    public syncContacts: boolean = false;
    public securityGroups: UserSecurityGroup[] = [];
    public apps: RelatedUserApp[] = [];
    public roles: RelatedUserRole[] = [];
    public users: RelatedUser[] = [];
    public myCommissionAccounts: any[];
    public managedTerritories: RelatedTerritory[] = [];
    public address: Address = null;
}